import React from 'react';

const IconMusic = () => (
<svg version="1.1" id="music-icon" xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
  viewBox="0 0 512 512"  space="preserve">
  <g>
    <g>
      <path d="M229.322,189.02c-9.406,0-17.029,7.623-17.029,17.029v99.902c0,9.406,7.623,17.029,17.029,17.029
			s17.029-7.623,17.029-17.029v-99.902C246.35,196.643,238.727,189.02,229.322,189.02z"/>
    </g>
  </g>
  <g>
    <g>
      <path d="M176.532,136.231c-9.406,0-17.029,7.623-17.029,17.029v205.487c0,9.406,7.623,17.029,17.029,17.029
			s17.029-7.623,17.029-17.034V153.259C193.561,143.854,185.938,136.231,176.532,136.231z"/>
    </g>
  </g>
  <g>
    <g>
      <path d="M123.175,86.847c-9.406,0-17.029,7.623-17.029,17.029v304.248c0,9.406,7.623,17.029,17.029,17.029
			s17.029-7.623,17.029-17.029V103.876C140.204,94.47,132.581,86.847,123.175,86.847z"/>
    </g>
  </g>
  <g>
    <g>
      <path d="M70.386,136.231c-9.406,0-17.029,7.623-17.029,17.029v205.487c0,9.406,7.623,17.029,17.029,17.029
			s17.029-7.623,17.029-17.034V153.259C87.415,143.854,79.791,136.231,70.386,136.231z"/>
    </g>
  </g>
  <g>
    <g>
      <path d="M17.029,185.614C7.623,185.614,0,193.237,0,202.643v106.714c0,9.406,7.623,17.029,17.029,17.029
			s17.029-7.618,17.029-17.029V202.643C34.058,193.237,26.434,185.614,17.029,185.614z"/>
    </g>
  </g>
  <g>
    <g>
      <path d="M388.825,86.847c-9.406,0-17.029,7.623-17.029,17.029v304.248c0,9.406,7.623,17.029,17.029,17.029
			s17.029-7.623,17.029-17.029V103.876C405.854,94.47,398.23,86.847,388.825,86.847z"/>
    </g>
  </g>
  <g>
    <g>
      <path d="M335.468,136.231c-9.406,0-17.029,7.623-17.029,17.029v205.487c0,9.406,7.623,17.029,17.029,17.029
			c9.406,0,17.029-7.623,17.029-17.034V153.259C352.497,143.854,344.873,136.231,335.468,136.231z"/>
    </g>
  </g>
  <g>
    <g>
      <path d="M282.679,162.909c-9.406,0-17.029,7.623-17.029,17.029v152.124c0,9.406,7.623,17.029,17.029,17.029
			c9.406,0,17.029-7.618,17.029-17.029V179.938C299.707,170.532,292.084,162.909,282.679,162.909z"/>
    </g>
  </g>
  <g>
    <g>
      <path d="M441.614,136.231c-9.406,0-17.029,7.623-17.029,17.029v205.487c0,9.406,7.623,17.029,17.029,17.029
			s17.029-7.623,17.029-17.034V153.259C458.643,143.854,451.02,136.231,441.614,136.231z"/>
    </g>
  </g>
  <g>
    <g>
      <path d="M494.971,185.614c-9.406,0-17.029,7.623-17.029,17.029v106.714c0,9.406,7.623,17.029,17.029,17.029
			c9.406,0,17.029-7.618,17.029-17.029V202.643C512,193.237,504.377,185.614,494.971,185.614z"/>
    </g>
  </g>
</svg>

);

export default IconMusic;
